/** The open `@query` ending at the cursor: `@` at the start or after whitespace, no space typed yet. */
export function mentionQueryAt(value, cursor) {
    const before = value.slice(0, cursor);
    const at = before.lastIndexOf('@');
    if (at < 0 || (at > 0 && !/\s/.test(before[at - 1])))
        return null;
    const query = before.slice(at + 1);
    return /\s/.test(query) ? null : { start: at, query };
}
/** Replace value[start, end) with `@Name `, adding a space before when the text runs on. */
export function insertMentionText(value, start, end, name) {
    const before = value.slice(0, start);
    const spacer = before && !/\s$/.test(before) ? ' ' : '';
    const token = `${spacer}@${name} `;
    return { value: before + token + value.slice(end), cursor: before.length + token.length };
}
const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
function mentionRe(members) {
    const names = [...new Set(members.map((m) => m.name.trim()).filter(Boolean))].sort((a, b) => b.length - a.length);
    if (!names.length)
        return null;
    return new RegExp(`(^|\\s)@(${names.map(escapeRe).join('|')})(?![\\p{L}\\p{N}_])`, 'gu');
}
/** Members whose `@Name` appears as a whole mention (longest name wins). */
export function mentionedMemberIds(text, members) {
    const re = mentionRe(members);
    if (!re)
        return [];
    const ids = new Set();
    for (const m of text.matchAll(re))
        for (const member of members)
            if (member.name.trim() === m[2])
                ids.add(member.id);
    return [...ids];
}
/** Plain and mention runs, for highlighting `@Name` bold brand blue. */
export function splitMentionText(text, members) {
    const re = mentionRe(members);
    const runs = [];
    let last = 0;
    if (re)
        for (const m of text.matchAll(re)) {
            const start = m.index + m[1].length;
            if (start > last)
                runs.push({ text: text.slice(last, start), mention: false });
            runs.push({ text: `@${m[2]}`, mention: true });
            last = start + m[2].length + 1;
        }
    if (last < text.length)
        runs.push({ text: text.slice(last), mention: false });
    return runs;
}
//# sourceMappingURL=descriptionMentions.js.map